// src/translations/yachtsPageTranslations.js
export const yachtsPageTranslations = {
    en: {
      findYourPerfectYacht: "Find Your Perfect Yacht",
      filters: {
        priceRange: "Price Range (€)",
        priceMinPlaceholder: "Min",
        priceMaxPlaceholder: "Max",
        minimumCapacity: "Minimum Capacity",
        capacityPlaceholder: "Min. Guests",
        duration: "Duration",
        durationAll: "All Durations",
        durationDay: "Day Trip",
        durationNight: "Night Trip",
        location: "Location",
        locationAll: "All Locations"
      },
      activeFilters: {
        price: "Price:",
        minCapacity: "Min Capacity:",
        duration: "Duration:",
        location: "Location:"
      },
      clearAllFilters: "Clear All Filters",
      availableYachts: "Available Yachts"
    },
    tr: {
      findYourPerfectYacht: "Mükemmel Yatınızı Bulun",
      filters: {
        priceRange: "Fiyat Aralığı (€)",
        priceMinPlaceholder: "Min",
        priceMaxPlaceholder: "Maks",
        minimumCapacity: "Minimum Kapasite",
        capacityPlaceholder: "Min. Misafir",
        duration: "Süre",
        durationAll: "Tüm Süreler",
        durationDay: "Günlük Gezi",
        durationNight: "Gece Gezisi",
        location: "Konum",
        locationAll: "Tüm Konumlar"
      },
      activeFilters: {
        price: "Fiyat:",
        minCapacity: "Min Kapasite:",
        duration: "Süre:",
        location: "Konum:"
      },
      clearAllFilters: "Tüm Filtreleri Temizle",
      availableYachts: "Mevcut Yatlar"
    },
    de: {
      findYourPerfectYacht: "Finden Sie Ihre perfekte Yacht",
      filters: {
        priceRange: "Preisspanne (€)",
        priceMinPlaceholder: "Min",
        priceMaxPlaceholder: "Max",
        minimumCapacity: "Mindestkapazität",
        capacityPlaceholder: "Min. Gäste",
        duration: "Dauer",
        durationAll: "Alle Dauern",
        durationDay: "Tagesausflug",
        durationNight: "Nachtausflug",
        location: "Standort",
        locationAll: "Alle Standorte"
      },
      activeFilters: {
        price: "Preis:",
        minCapacity: "Min Kapazität:",
        duration: "Dauer:",
        location: "Standort:"
      },
      clearAllFilters: "Alle Filter löschen",
      availableYachts: "Verfügbare Yachten"
    },
    ru: {
      findYourPerfectYacht: "Найдите свою идеальную яхту",
      filters: {
        priceRange: "Диапазон цен (€)",
        priceMinPlaceholder: "Мин",
        priceMaxPlaceholder: "Макс",
        minimumCapacity: "Минимальная вместимость",
        capacityPlaceholder: "Мин. гостей",
        duration: "Продолжительность",
        durationAll: "Все продолжительности",
        durationDay: "Дневная поездка",
        durationNight: "Ночная поездка",
        location: "Местоположение",
        locationAll: "Все местоположения"
      },
      activeFilters: {
        price: "Цена:",
        minCapacity: "Мин вместимость:",
        duration: "Продолжительность:",
        location: "Местоположение:"
      },
      clearAllFilters: "Очистить все фильтры",
      availableYachts: "Доступные яхты"
    }
  };